<template>
  <page :load="doInit">
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12 md3>
          <v-navigation-drawer permanent light width="100%" class="mavSmallMenu">
              <v-toolbar flat>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-content>
                      <v-list-tile-title class="title">
                        {{ this.campaign }}
                      </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-toolbar>
              <v-list class="pt-0">
                <v-divider></v-divider>
                <v-list-tile v-for="item in sideMenu" :key="item.name" :to="{ name: item.name }">
                  <v-list-tile-action>
                    <v-icon>{{ item.icon }}</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.text }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-navigation-drawer>
        </v-flex>
        <v-flex xs12 md9>
          <transition name="slide-x-transition" mode="out-in">
            <router-view ></router-view>
          </transition>
        </v-flex>
      </v-layout>
    </v-container>
  </page>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      sideMenu: [
        { name: 'campaignQuery', text: 'Campaign', icon: 'mdi-calendar-clock' },
        { name: 'campaignPromotionQuery', text: 'Promotions', icon: 'mdi-star' },
        { name: 'productCampaignQuery', text: 'Products', icon: 'mdi-cube-outline' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ])
  },
  methods: {
    ...mapActions([
      'campaignInit'
    ]),
    async doInit() {
      await this.campaignInit(this.campaign)
      if (!this.$store.state.promotionManagement.campaign.allIntermediary) {
        this.sideMenu.push({ name: 'intermediaryCampaignQuery', text: 'Intermediaries', icon: 'mdi-account' })
      }
    }
  },
  props: {
    campaign: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
</style>
